import axios from 'axios';

export default function csrf() {
  return document.querySelector('[name="csrf-token"]').content;
}

export function setupCSRFToken() {
  axios.defaults.headers.common['X-CSRF-Token'] = csrf();
}
